module.exports = __webpack_public_path__ + "img/banner.90ba1d5a.jpg";